export function getFileName(file) {
    if (!file)
        return null;
    return file.name;
}
